import { Component, componentMixin } from '@resn/gozer-core/component';
import ThreeObjectMixin from '@resn/gozer-core-mixins/three-object';
import { Mesh, MeshBasicMaterial, PlaneBufferGeometry } from 'three';

@componentMixin(ThreeObjectMixin)
class SimpleQuad extends Component {
    options = {};

    props = {};

    async onSetup() {
        const { layer, nameMesh, renderOrder } = this.options;

        const shader = this.options.shader || new MeshBasicMaterial({ color: 'red' });

        const quad = (this.quad = new Mesh(new PlaneBufferGeometry(1, 1), shader));
        quad.name = nameMesh || 'MeshSimple';
        quad.layers.set(layer);
        quad.renderOrder = renderOrder;

        this.object.add(quad);
    }
}
export default SimpleQuad;
